module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4WxKOzY.22786f24.woff2";